import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { EditInboundDeliveryMutation } from "../../../graphql/deliveryService/mutations/editInboundDelivery";
import { handleError } from "../../../utils/graphqlHelper";

interface EditInboundDeliveryMutationProps {
  dataAction: (id: string) => void;
  errorAction?: () => void;
}

const useEditInboundDeliveryMutation = (
  props: EditInboundDeliveryMutationProps,
) => {
  const { t } = useTranslation();
  const { dataAction, errorAction } = props;

  const mutation = useMutation(EditInboundDeliveryMutation, {
    update: (cache, result) => {
      const data = result.data?.editInboundDelivery.inboundDeliveryDetail;
      if (!data) return;

      const cacheId = cache.identify({
        __typename: "InboundDeliveryDetail",
        id: data.id,
      });
      cache.evict({ id: cacheId });
      cache.evict({ fieldName: "inboundDeliveries" });
      cache.gc();
    },
  });

  const { data, error } = mutation[1];

  const updatedInboundDelivery =
    data?.editInboundDelivery.inboundDeliveryDetail;

  useEffect(() => {
    if (!error) return;

    handleError(t("editInboundDeliveryError"), error.message, errorAction);
  }, [error]);

  useEffect(() => {
    if (!data || !updatedInboundDelivery) return;

    dataAction(updatedInboundDelivery.id);
  }, [data]);

  return mutation;
};

export default useEditInboundDeliveryMutation;
